import _ from 'lodash';
import { EmployeeTemplateOptionModel } from '../../../../models/EmployeeTemplateOptionModel';

export const getSetOptions = (
  options: EmployeeTemplateOptionModel[],
): EmployeeTemplateOptionModel[] => {
  return _.orderBy(
    options.filter(o => o.itSet),
    ['order', 'asc'],
  );
};
export const getNotSetOptions = (
  options: EmployeeTemplateOptionModel[],
): EmployeeTemplateOptionModel[] => {
  return _.orderBy(
    options.filter(o => !o.itSet),
    ['order', 'asc'],
  );
};

export const calculateDirection = (drag: HTMLElement, drop: HTMLElement) => {
  const dragRect = drag.getBoundingClientRect();
  const dropRect = drop.getBoundingClientRect();

  return dragRect.top + dragRect.height / 2 < dropRect.top + dropRect.height / 2
    ? 'before'
    : 'after';
};

export const inRange = (min: number, max: number, index: number) => {
  return Math.max(min, Math.min(max, index));
};
